const orders = [
  {
    id: "ord_5001",
    number: "WWG-25-0001",
    status: "processing",
    iboId: "ibo_42",
    customerName: "Dana Rivera",
    placedAt: "2025-06-18T15:22:00Z",
    totalCents: 6200,
    currency: "USD",
    items: [
      {
        sku: "WWG-TS-BLK-M",
        variationId: "var_1",
        quantity: 2,
        unitPriceCents: 2500,
      },
      {
        sku: "WWG-MUG-WHT",
        variationId: null,
        quantity: 1,
        unitPriceCents: 1200,
      },
    ],
    attachments: [],
    notes: "Ship with gift card insert.",
  },
  {
    id: "ord_5002",
    number: "WWG-25-0002",
    status: "shipped",
    iboId: "ibo_77",
    customerName: "Marc Lin",
    placedAt: "2025-06-19T11:01:00Z",
    totalCents: 1800,
    currency: "USD",
    items: [
      {
        sku: "WWG-CAP-NAV-OS",
        variationId: "var_3",
        quantity: 1,
        unitPriceCents: 1800,
      },
    ],
    attachments: [
      {
        id: "att_1",
        filename: "label.pdf",
        url: "https://example.invalid/att/att_1",
      },
    ],
    notes: "",
  },
  {
    id: "ord_5003",
    number: "WWG-25-0003",
    status: "pending",
    iboId: "ibo_42",
    customerName: "Priya Shah",
    placedAt: "2025-06-20T09:44:00Z",
    totalCents: 2500,
    currency: "USD",
    items: [
      {
        sku: "WWG-TS-BLK-L",
        variationId: "var_2",
        quantity: 1,
        unitPriceCents: 2500,
      },
    ],
    attachments: [],
    notes: "",
  },
];

export default orders;
